import React from "react"
import classnames from "classnames"

import styles from "./styles.css"

const HistoryOnlineInterfaceSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)

  const itemTableClasses = classnames(styles.skeleton)
  const itemsClasses = classnames(styles.itemsClasses)
  const itemValueClasses = classnames(styles.skeleton, styles.itemValue)

  return (
    <div className={mainSectionClasses}>
      <div className={titleClasses}></div>

      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            <th className={itemTableClasses}></th>
            <th className={itemTableClasses}></th>
            <th className={itemTableClasses}></th>
            <th className={itemTableClasses}></th>
            <th className={itemTableClasses}></th>
          </tr>
        </thead>

        <tbody className={styles.tableBody}>
          <tr className={itemsClasses}>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
          </tr>

          <tr className={itemsClasses}>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
          </tr>

          <tr className={itemsClasses}>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
            <th className={itemValueClasses}></th>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
export default HistoryOnlineInterfaceSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/HistoryOnlineInterfaceSkeleton/index.js